import * as React from 'react'
import { styled } from '../../../../stitches.config'
import 'react-modern-drawer/dist/index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import isEmpty from 'lodash/isEmpty'
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
import {
    SALES_PHONE_NUMBER_FORMATTED,
    SUPPORT_PHONE_NUMBER_FORMATTED,
    SALES_PHONE_NUMBER_TEL,
    SUPPORT_PHONE_NUMBER_TEL,
    SALES_PHONE_NUMBER_DATA_ID,
} from '../../marketing/text/PhoneNumbers/strings'

const PromoBannerWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: '.5rem',
    px: '5vw',
    py: '0.35rem',
    color: '$white',
    fontSize: '$3',
    '& p': {
        color: '$white',
        margin: 0,
    },
    '@md': {
        px: '10vw',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    variants: {
        theme: {
            consumer: {
                linearGradient: 'to top right,$primary,$secondary',
                backgroundColor: '$primary',
            },
            corporate: {
                backgroundColor: '$secondaryDark',
            },
        },
    },
})

export interface IPromoBanner {
    promoBannerHtml: string
    isCorporate: boolean
}

const CorporateContactInfo = (
    <p>
        <FontAwesomeIcon icon={faPhone}></FontAwesomeIcon>
        &nbsp;&nbsp;Talk to a sales agent:{' '}
        <a
            href={SALES_PHONE_NUMBER_TEL}
            data-phone={SALES_PHONE_NUMBER_DATA_ID}
        >
            {SALES_PHONE_NUMBER_FORMATTED}
        </a>
    </p>
)

const ConsumerContactInfo = (
    <p>
        <FontAwesomeIcon icon={faPhone}></FontAwesomeIcon>
        &nbsp;&nbsp;Talk to a real customer service agent:{' '}
        <a href={SUPPORT_PHONE_NUMBER_TEL}>{SUPPORT_PHONE_NUMBER_FORMATTED}</a>
    </p>
)

const PromoBanner: React.FC<IPromoBanner> = ({
    promoBannerHtml,
    isCorporate,
}) => {
    return (
        <PromoBannerWrapper theme={isCorporate ? 'corporate' : 'consumer'}>
            <div>
                {isCorporate ? CorporateContactInfo : ConsumerContactInfo}
            </div>
            {!isEmpty(promoBannerHtml) && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: promoBannerHtml,
                    }}
                />
            )}
        </PromoBannerWrapper>
    )
}

export default PromoBanner
